const ProgressBar = ({ step, totalSteps }) => {
    const progress = (step / totalSteps) * 100;
  
    return (
      <div style={{ width: '100%', background: '#E2E2E2', height: '32px', borderRadius: '20px', borderColor: '#0000000' }}>
        <div
          style={{
            width: `${progress}%`,
            background: '#00CEA0',
            height: '30px',
            left: '29px',
            borderRadius: '50px',
          }}
        ></div>
      </div>
    );
  };
  
  export default ProgressBar;
  